export default __webpack_public_path__ + "static/media/Panama.8667769d.svg";